import { useState } from "react"
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"

export default function ConfirmDelete(props) {
    const [open, setOpen] = useState(false)

    const action = () => {
        if (props.enabled) {
            props.action()
            setOpen(false)
        }
    }

    return (
        <>
            <Modal isOpen={open} toggle={() => setOpen(!open)}>
                <ModalHeader>{props.modalTitle || "Confirmar exclusão"}</ModalHeader>
                <ModalBody>
                    <p style={{ fontSize: '14px' }}>{props.modalMessage || <>Você tem certeza que deseja deletar? <br />Essa ação não poderá ser desfeita.</>}</p>
                </ModalBody>
                <ModalFooter>
                    <div className="float-right">
                        <button onClick={action} className="hdv-btn-forms hdv-btn-red mr-2">Sim</button>
                        <button className="hdv-btn-forms hdv-btn-default mr-0" onClick={() => setOpen(false)}>Cancelar</button>
                    </div>
                </ModalFooter>
            </Modal>
            {props.type === "automacao" ? (
                <button onClick={() => setOpen(true)} className="hdv-btn-forms hdv-btn-red hdv-automacao-delete-button" style={{ border: 'none !important' }}>
                    <i className="fa fa-times fa-2x"></i>
                </button>
            ) : props.type === "contato" ? (
                <i onClick={() => setOpen(true)} className="fa fa-times fa-2x" style={{ backgroundColor: "#e34b4b", color: "#fff", cursor: "pointer" }}></i>
            ) : props.type === "parametro" ? (
                <div className="row" style={{ marginRight: '6px' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <button
                            onClick={() => { setOpen(true) }}
                            style={{ color: '#fff', width: '65px' }}
                            className="hdv-chart-close  hdv-btn-red hdv-automacao-delete-button d-flex align-items-center">
                            <i className="fa fa-times" style={{ fontSize: '22px' }}></i> Deletar
                        </button>
                    </div>
                </div>
            ) : props.type === 'exportacao' ? (
                <div onClick={() => setOpen(true)} title={`Excluir coluna ${props.key + 1}`} style={{ background: "#e64444", borderRadius: "10px", padding: "4px 3px 0px 2px", cursor: "pointer" }}>
                    <i style={{ color: "white", fontSize: "22px" }} className="las la-times"></i>
                </div>

            ) : props.type === 'trash' ? (
                <div
                    onClick={() => setOpen(true)}
                    title={props.title}
                >
                    <i className="fa fa-trash-alt fa-25px"></i>
                </div>
            ) : (
                <button
                    disabled={!props.enabled}
                    onClick={() => setOpen(true)}
                    style={{ border: 'none !important' }}
                    className={"hdv-btn-forms hdv-btn-red" + (props.enabled ? "" : "hdv-btn-disable")}>
                    {props.label || "Excluir"}
                </button>
            )}
        </>
    )
}

